angular.module('picmonic-common').directive('atlasCopy', [
  function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('copy', function (event) {
          if (typeof atlasEvent !== 'undefined') {
            if (!attrs.atlasAction) {
              attrs.atlasAction = 'click';
            }

            atlasEvent(attrs.atlasAction, attrs.atlasCopy);
          }
        });
      },
    };
  },
]);
